export const BACKGROUND_COLOR = "#F0F0F7";
export const PURPLE_COLOR = "#473BF0";
export const DARK_BLUE_BACKGROUND_COLOR = "rgb(28, 44, 63)";
export const BODY_BACKGROUND_COLOR = "#FCFDFE";
export const WHITE_COLOR = "#ffffff";
export const FOOTER_LINK_COLOR = "#161C2D";
export const SKY_BLUE_COLOR = "#3B86FF";
